function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  //if (summary.nextElementSibling.getAttribute('id')) {
  if (summary.nextElementSibling && summary.nextElementSibling.hasAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

function initQuickOrderAccordions(root = document) {
  const accordions = root.querySelectorAll?.('.quick-order-accordion');
  if (!accordions || !accordions.length) return;

  accordions.forEach((accordion) => {
    if (accordion.dataset.accordionBound === 'true') return;
    accordion.dataset.accordionBound = 'true';

    const header = accordion.querySelector('.quick-order-accordion__header');
    const content = accordion.querySelector('.quick-order-accordion__content');
    const stateLabel = header?.querySelector('.quick-order-accordion__summary-state');

    if (!header || !content || !stateLabel) return;

    const openText = header.dataset.openText || 'OPEN';
    const closeText = header.dataset.closeText || 'CLOSE';

    const toggle = () => {
      const isOpen = content.style.display !== 'none';

      if (isOpen) {
        content.style.display = 'none';
        stateLabel.textContent = openText;
        accordion.classList.remove('is-open');
      } else {
        content.style.display = 'block';
        stateLabel.textContent = closeText;
        accordion.classList.add('is-open');
      }
    };

    header.addEventListener('click', toggle);
    stateLabel.textContent = openText;
  });
}

document.addEventListener('DOMContentLoaded', () => initQuickOrderAccordions());

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

// Global protection state that survives component recreation
const quantityProtectionState = new Map();

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.userInitiated = false;
    this.lastUserValue = null;
    this.expectedValue = null;
    this.componentId = Math.random().toString(36).substr(2, 9);

    this.protectedSetValue(this.input);

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.input.addEventListener('input', this.onUserInput.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  protectedSetValue(input) {
    const originalDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    const originalSet = originalDescriptor.set;
    const originalGet = originalDescriptor.get;
    const variantId = input.dataset.index;

    Object.defineProperty(input, 'value', {
      set: function(newValue) {
        const protectionState = quantityProtectionState.get(String(variantId));
        const isProtected = protectionState && protectionState.userInitiated;
        const lastUserValue = protectionState ? protectionState.lastUserValue : null;
        const incomingValue = parseInt(newValue);
        const currentValue = parseInt(originalGet.call(this)); // Use original getter

        if (isProtected && lastUserValue !== null && incomingValue !== lastUserValue) {
          return;
        }

        originalSet.call(this, newValue);
      },
      get: originalGet
    });
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onUserInput(event) {
    this.userInitiated = true;
    this.lastUserValue = this.input.value;

    clearTimeout(this.userInputTimeout);
    this.userInputTimeout = setTimeout(() => {
      this.userInitiated = false;
    }, 1000);
  }

  onButtonClick(event) {
    event.preventDefault();
    const button = event.currentTarget;
    if (button?.classList.contains('disabled') || button?.getAttribute('aria-disabled') === 'true' || button?.hasAttribute('disabled')) {
      return;
    }

    const previousValue = this.input.value;
    button.name === 'plus' ? this.input.stepUp() : this.input.stepDown();

    const variantId = this.input.dataset.index;
    const expectedValue = parseInt(this.input.value);

    quantityProtectionState.set(variantId, {
      userInitiated: true,
      expectedValue: expectedValue,
      timestamp: Date.now(),
      lastUserValue: expectedValue
    });

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    const buttonMinus = this.querySelector(".quantity__button[name='minus']");
    const buttonPlus = this.querySelector(".quantity__button[name='plus']");

    if (buttonMinus) {
      const disableMinus = value <= 0;
      buttonMinus.classList.toggle('disabled', disableMinus);
      buttonMinus.toggleAttribute('disabled', disableMinus);
      buttonMinus.setAttribute('aria-disabled', disableMinus ? 'true' : 'false');
    }

    const datasetMax = parseInt(this.input.dataset.max);
    const attrMax = this.input.hasAttribute('max') ? parseInt(this.input.getAttribute('max')) : NaN;
    const available = parseInt(this.input.dataset.available);
    const inventoryPolicy = this.input.dataset.inventoryPolicy;

    let effectiveMax = Number.isNaN(datasetMax) ? null : datasetMax;
    if (!Number.isNaN(attrMax)) {
      effectiveMax = effectiveMax !== null ? Math.min(effectiveMax, attrMax) : attrMax;
    }

    if (inventoryPolicy === 'deny' && !Number.isNaN(available)) {
      effectiveMax = effectiveMax !== null ? Math.min(effectiveMax, available) : available;
    }

    if (typeof effectiveMax === 'number' && buttonPlus) {
      const disablePlus = value >= effectiveMax;
      buttonPlus.classList.toggle('disabled', disablePlus);
      buttonPlus.toggleAttribute('disabled', disablePlus);
      buttonPlus.setAttribute('aria-disabled', disablePlus ? 'true' : 'false');
      this.input.dataset.effectiveMax = effectiveMax;

      if (value > effectiveMax && !this.userInitiated) {
        this.input.value = effectiveMax;
      }
    } else if (buttonPlus) {
      buttonPlus.classList.remove('disabled');
      buttonPlus.removeAttribute('disabled');
      buttonPlus.setAttribute('aria-disabled', 'false');
      this.input.dataset.effectiveMax = '';
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.isTouch = window.matchMedia('(hover: none)').matches;

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else if (detailsElement.hasAttribute('data-accordion')) {
      // Accordion: native <details> handles open/close, skip panel slide
      summaryElement.setAttribute('aria-expanded', !isOpen);
      if (this.isTouch) {
        setTimeout(() => summaryElement.blur(), 0);
      }
      return;
    } else {
      // Reset all accordions inside this panel. Safari iOS caches stale
      // layout on <details> elements, so we force a reflow by toggling
      // display on the <details> element itself.
      detailsElement.querySelectorAll('details[data-accordion]').forEach((acc) => {
        acc.removeAttribute('open');
        acc.style.display = 'none';
        acc.offsetHeight; // force Safari to recalculate layout
        acc.style.display = '';
        const s = acc.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'false');
      });
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    // Close any open accordions inside this panel
    detailsElement.querySelectorAll('details[data-accordion][open]').forEach((accordion) => {
      accordion.removeAttribute('open');
      const accSummary = accordion.querySelector('summary');
      if (accSummary) accSummary.setAttribute('aria-expanded', false);
    });
    const summaryElement = detailsElement.querySelector('summary');
    summaryElement.setAttribute('aria-expanded', false);
    removeTrapFocus(summaryElement);
    if (this.isTouch) {
      summaryElement.blur();
    }
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        // When the main drawer finishes closing, reset all child state.
        // Doing this here (after the drawer is fully hidden) avoids
        // Safari iOS caching stale layout from mid-transition changes.
        if (detailsElement === this.mainDetailsToggle) {
          this.resetChildState();
        } else if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
          if (this.isTouch) {
            detailsElement.querySelector('summary').blur();
          }
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector('.announcement-bar-slider')) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener('change', () => {
          if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener('click', () => {
          this.announcementBarArrowButtonWasClicked = true;
        }, {once: true});
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || !this.desktopLayout.matches ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked && this.desktopLayout.matches) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      // Variant exists — remove the CSS-based BIS hide so the app can control visibility
      document.body.classList.remove('bis-force-hide');
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
          skuDestination.classList.remove('sku--unavailable');
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    // Keep price visible for better UX - users can still see approximate pricing
    if (inventory) inventory.classList.add('visibility-hidden');
    // Show helpful message in SKU area instead of hiding it
    if (sku) {
      sku.classList.remove('visibility-hidden');
      sku.classList.add('sku--unavailable');
      sku.textContent = 'Not available in this combination';
    }
    // Force-hide BIS button via CSS class — can't be overridden by the app's inline styles
    document.body.classList.add('bis-force-hide');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          // e13: the complementary block renders <e13-addon-carousel>, not
          // Dawn's <slideshow-component>. Treat either as "has content".
          if (
            !this.querySelector('slideshow-component, e13-addon-carousel') &&
            this.classList.contains('complementary-products')
          ) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// Remove button functionality is now handled within QuickOrderList.initializeCustomElements()

// Remove all button functionality is now handled within QuickOrderList.initializeCustomElements()

class QuickOrderList extends HTMLElement {
  constructor() {
    super();
    this.cart = {};
    this.pendingRequests = new Map(); // Track pending requests by variant ID
    this.queuedRequests = new Map(); // Queue latest quantity for pending variants
    this.latestRequestedQuantities = new Map(); // Track the most recent quantity the user requested per variant
    this.chunkedRequests = new Map(); // Track in-progress chunked quantity updates
    this.defineInputsAndSections();
    initQuickOrderAccordions();

    const debouncedOnChange = debounce((event) => {
      if (parseInt(event.target.value) === 0) {
        const index = event.target.dataset.index;
        this.updateQuantity(index, 0, event.target);
      } else {
        this.onChange(event);
      }
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'quick-order') {
        return;
      }
      // If its another section that made the update
      // Fetch the current cart first, then refresh with that data
      fetch(`${routes.cart_url}.js`)
        .then(response => response.json())
        .then(cart => {
          return this.refresh({ preserveInputValues: false, cartData: cart });
        })
        .then(() => {
          this.defineInputsAndSections();
          initQuickOrderAccordions();
        })
        .catch((error) => {
          console.error('[QuickOrderList] Failed to refresh after cart update:', error);
        });
    });

    // Initialize cart quantities on load
    this.initializeCartQuantities();
  }

  initializeCartQuantities() {
    // Fetch current cart state and update quantities
    fetch(`${routes.cart_url}.js`)
      .then(response => response.json())
      .then(cart => {
        this.cart = cart;
        this.latestRequestedQuantities.clear();
        // First, set all quantity inputs to 0 (default state)
        this.querySelectorAll('input[type="number"]').forEach(input => {
          if (input.id && input.id.startsWith('Quantity-')) {
            input.value = 0;
            input.setAttribute('data-cart-quantity', 0);
          }
        });
        this.querySelectorAll('[data-variant-id]').forEach(row => {
          row.setAttribute('data-cart-qty', 0);
        });
        
        // Then update with actual cart quantities
        if (cart && cart.items) {
          cart.items.forEach(item => {
            this.syncVariantQuantityDisplay(item.variant_id, item.quantity);
            this.latestRequestedQuantities.set(String(item.variant_id), item.quantity);
          });
          // Update totals with fresh cart data
          this.updateVariantTotals(cart);
        }
      })
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  defineInputsAndSections() {
    this.cartItems = this.querySelectorAll('.quick-order-list__item');
    this.itemsContainer = this.querySelector('.quick-order-list__table tbody');
    this.instructions = this.querySelector('.quick-order-list-total__instructions');
    this.subtotal = this.querySelector('[data-cart-subtotal]');
    this.quantity = this.querySelector('[data-cart-quantity]');
    
    // Re-initialize custom elements after section updates
    this.initializeCustomElements();
  }

  initializeCustomElements() {
    // Re-initialize remove buttons - look for buttons inside the custom elements
    this.querySelectorAll('quick-order-list-remove-button').forEach(customElement => {
      const button = customElement.querySelector('button');
      if (button && !button.hasAttribute('data-initialized')) {
        button.setAttribute('data-initialized', 'true');
        const allVariants = customElement.dataset.allVariants === 'true';
        const variantId = customElement.dataset.index;
        
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.updateQuantity(variantId, 0, document.activeElement, allVariants);
        });
      }
    });

    // Re-initialize remove all buttons - look for buttons inside the custom elements  
    this.querySelectorAll('quick-order-list-remove-all-button').forEach(customElement => {
      const button = customElement.querySelector('button');
      if (button && !button.hasAttribute('data-initialized')) {
        button.setAttribute('data-initialized', 'true');
        
        button.addEventListener('click', (event) => {
          event.preventDefault();
          customElement.setAttribute('disabled', '');
          
          // Build updates object to remove all variants currently in cart
          const updates = {};
          this.querySelectorAll('[data-variant-id]').forEach(variantRow => {
            const variantId = variantRow.dataset.variantId;
            const cartQty = parseInt(variantRow.dataset.cartQty) || 0;
            if (cartQty > 0) {
              updates[variantId] = 0;
            }
          });
          
          this.updateMultipleQty(updates);
        });
      }
    });
  }

  captureViewState() {
    const inputValues = {};
    this.querySelectorAll('input[type="number"]').forEach(input => {
      inputValues[input.id] = input.value;
    });

    const loadingVariants = [];
    this.querySelectorAll('[data-variant-total]').forEach(cell => {
      const overlay = cell.querySelector('.loading-overlay');
      if (overlay && !overlay.classList.contains('hidden')) {
        loadingVariants.push(cell.dataset.variantTotal);
      }
      const busyButton = cell.querySelector('quick-order-list-remove-all-button button[aria-busy="true"]');
      if (busyButton) {
        loadingVariants.push(cell.dataset.variantTotal);
      }
    });

    const mediaNodes = new Map();
    this.querySelectorAll('[data-variant-id]').forEach(row => {
      const media = row.querySelector('.variant-item__media');
      if (media) {
        mediaNodes.set(row.dataset.variantId, media);
      }
    });

    return { inputValues, loadingVariants, mediaNodes };
  }

  restoreInputState(values = {}, skipVariantId = null) {
    const skipId = skipVariantId !== null && skipVariantId !== undefined ? String(skipVariantId) : null;
    Object.keys(values).forEach((inputId) => {
      if (skipId && (inputId === `Quantity-${skipId}` || inputId === `updates_${skipId}`)) {
        return;
      }
      const input = document.getElementById(inputId);
      if (input) {
        // Check if this input is protected by global state
        const variantId = input.dataset.index;
        const protectionState = quantityProtectionState.get(String(variantId));
        const isProtected = protectionState && protectionState.userInitiated;
        const expectedValue = protectionState ? protectionState.expectedValue : null;
        const incomingValue = parseInt(values[inputId]);

        if (isProtected && expectedValue !== null && incomingValue < expectedValue) {
          return;
        }

        input.value = values[inputId];
      }
    });

    if (skipId) {
      const forcedValue = this.latestRequestedQuantities.get(skipId);
      if (forcedValue !== undefined) {
        this.getVariantInputs(skipId).forEach((input) => {
          input.value = forcedValue;
        });
      }
    }
  }

  restoreLoadingState(loadingVariants = []) {
    loadingVariants.forEach(variantId => {
      if (!variantId) {
        return;
      }
      this.enableVariantLoading(variantId);
    });
  }

  restoreMediaContent(mediaNodes = new Map()) {
    mediaNodes.forEach((mediaNode, variantId) => {
      if (!mediaNode || !variantId) {
        return;
      }
      const newRow = this.querySelector(`[data-variant-id="${variantId}"]`);
      if (!newRow) {
        return;
      }
      const placeholder = newRow.querySelector('.variant-item__media');
      if (placeholder) {
        placeholder.replaceWith(mediaNode);
      }
    });
  }

  onChange(event) {
    const inputValue = parseInt(event.target.value);
    const cartQuantity = parseInt(event.target.dataset.cartQuantity) || 0;
    const index = event.target.dataset.index;
    const name = document.activeElement.getAttribute('name');

    if (inputValue < 0) {
      event.target.value = cartQuantity;
      return;
    }
    
    const isRequestPending = this.pendingRequests.has(index);
    const shouldProcessChange = inputValue !== cartQuantity || isRequestPending;

    if (shouldProcessChange) {
      this.updateQuantity(index, inputValue, event.target, false, name);
    }
  }

  updateMultipleQty(updates) {
    this.querySelector('.quick-order-list__total').classList.add('loading');
    
    // Show loading for all variant totals since we're updating multiple items
    this.querySelectorAll('.loading-overlay').forEach(overlay => overlay.classList.remove('hidden'));

    const body = JSON.stringify({
      updates,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        if (!response.ok) {
          return response.text().then(text => {
            console.error('[updateMultipleQty] HTTP error response:', text);
            throw new Error(`HTTP error! status: ${response.status}`);
          });
        }
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.cart = parsedState.cart || parsedState;
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-order', cartData: parsedState });

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.getElementById(section.id);

          if (section.id === 'quick-order-list') {
            if (elementToReplace && parsedState.sections[section.section]) {
              // Capture media nodes to prevent flashing
              const mediaNodes = new Map();
              this.querySelectorAll('[data-variant-id]').forEach(row => {
                const media = row.querySelector('.variant-item__media');
                if (media) {
                  mediaNodes.set(row.dataset.variantId, media);
                }
              });

              this.querySelectorAll('[data-initialized]').forEach(el => {
                el.removeAttribute('data-initialized');
              });

              const selectorElement = elementToReplace.querySelector(section.selector);
              if (selectorElement) {
                // Temporarily hide the section to prevent flash
                const originalVisibility = selectorElement.style.visibility;
                selectorElement.style.visibility = 'hidden';

                selectorElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

                // Restore media immediately
                this.restoreMediaContent(mediaNodes);

                // Restore visibility
                selectorElement.style.visibility = originalVisibility;
              }

              // Don't restore input values - we want the fresh values from server (0)
            }
          } else {
            const targetElement = elementToReplace?.querySelector(section.selector) || elementToReplace;
            if (targetElement && parsedState.sections[section.section]) {
              targetElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }
        });

        // Update variant totals manually since Liquid filters don't update via AJAX
        this.updateVariantTotals(this.cart);
        this.clearGlobalError();

        // Trigger BOLD.common integration for third-party apps
        if (typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.eventEmitter !== 'undefined') {
          BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', this.cart);
        }
      })
      .catch((error) => {
        console.error('[updateMultipleQty] Error:', error);
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.showGlobalError(this.getDefaultErrorMessage());
      })
      .finally(() => {
        this.querySelector('.quick-order-list__total').classList.remove('loading');
        
        // Hide all loading spinners
        this.querySelectorAll('.loading-overlay').forEach(overlay => overlay.classList.add('hidden'));

        if (this.cart && this.cart.item_count === 0) {
          const removeAllButton = this.querySelector('.quick-order-list-remove-all-button');
          if (removeAllButton) removeAllButton.setAttribute('disabled', '');
        }
        Object.keys(updates).forEach((variantId) => {
          const finalQty = this.getCartQuantityForVariant(variantId);
          this.latestRequestedQuantities.set(String(variantId), finalQty);
        });
        this.defineInputsAndSections();
        initQuickOrderAccordions();
      });
  }

  updateQuantity(id, quantity, sourceInput, variantArray, activeElementName) {
    let requestFailed = false;

    let quantityElement = null;
    if (sourceInput instanceof HTMLElement && sourceInput.closest('quick-order-list')) {
      quantityElement = sourceInput;
    }
    if (!quantityElement) {
      quantityElement = this.getQuantityInputElement(id);
    }

    const cartQuantityAttr = parseInt(quantityElement?.dataset.cartQuantity);
    let currentCartQty = Number.isNaN(cartQuantityAttr) ? this.getCartQuantityForVariant(id) : cartQuantityAttr;
    if (Number.isNaN(currentCartQty)) {
      currentCartQty = 0;
    }

    let requestedQuantity = parseInt(quantity);
    if (Number.isNaN(requestedQuantity) || requestedQuantity < 0) {
      requestedQuantity = 0;
    }

    let targetQuantity = requestedQuantity;

    const maxPermitted = this.getMaxPermittedQuantity(id);
    const exceededLimit = maxPermitted !== null && targetQuantity > maxPermitted;

    if (exceededLimit) {
      targetQuantity = maxPermitted;
      if (quantityElement) {
        quantityElement.value = maxPermitted;
      }
    }

    this.latestRequestedQuantities.set(String(id), targetQuantity);

    const requestInFlight = this.pendingRequests.has(id);

    if (!requestInFlight && this.queuedRequests.has(id)) {
      this.queuedRequests.delete(id);
    }

    // If a request is pending for this variant, queue the latest quantity
    if (requestInFlight) {
      this.queuedRequests.set(id, {
        quantity: targetQuantity,
        sourceInput: quantityElement,
        variantArray: variantArray,
        activeElementName: activeElementName
      });
      return;
    }

    if (targetQuantity === currentCartQty && !this.pendingRequests.has(id) && !this.queuedRequests.has(id)) {
      this.resetQuantityInputToCartQuantity(id);
      this.applyLimitState(id, currentCartQty, { limitReached: exceededLimit });
      return;
    }

    this.querySelector('.quick-order-list__total').classList.add('loading');
    
    // Show loading spinner for the specific variant total
    this.enableVariantLoading(id);

    // Check if item is already in cart by looking at current data-cart-quantity
    const quantityDiff = targetQuantity - currentCartQty;
    
    // If the quantity jump is too large (more than 5 items), break it into smaller chunks
    const MAX_QUANTITY_JUMP = 5;
    if (Math.abs(quantityDiff) > MAX_QUANTITY_JUMP && currentCartQty === 0) {
      this.handleLargeQuantityChange(id, currentCartQty, targetQuantity, quantityElement, variantArray, activeElementName);
      return;
    }
    
    let routeUrl, requestData;
    
    if (currentCartQty === 0 && targetQuantity > 0) {
      // Item not in cart and we're adding - use cart/add
      routeUrl = routes.cart_add_url;
      requestData = {
        items: [
          {
            id: parseInt(id),
            quantity: targetQuantity
          }
        ],
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      };
    } else {
      // Item already in cart OR we're removing/updating - use cart/update
      routeUrl = routes.cart_update_url;
      const updates = {};
      updates[id] = targetQuantity;
      requestData = {
        updates: updates,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      };
    }
    
    const body = JSON.stringify(requestData);
    const fetchConfigObject = fetchConfig();

    // Mark request as pending
    this.pendingRequests.set(id, true);

    fetch(routeUrl, { ...fetchConfigObject, ...{ body } })
      .then((response) => {
        if (!response.ok) {
          // Get the error details from the response
          return response.text().then(errorText => {
            console.error(`HTTP ${response.status} error:`, errorText);
            throw new Error(`HTTP error! status: ${response.status}, details: ${errorText}`);
          });
        }
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        if (parsedState.description || parsedState.errors) {
          requestFailed = true;
          const errorText = parsedState.description || this.extractFirstError(parsedState.errors) || this.getDefaultErrorMessage();
          this.handleQuantityError(id, errorText, { rawMessage: true });
          return;
        }

        this.cart = parsedState.cart;
        let actualCartQty = this.resolveCartQuantityFromResponse(parsedState, id);

        // Update internal cart reference
        this.cart = parsedState.cart || parsedState;

        this.updateLiveRegions(id, this.cart);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-order', cartData: parsedState });

        // Update sections but preserve input values and handle loading states
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.getElementById(section.id);

          if (section.id === 'quick-order-list') {
            // For the main quick order list, preserve current input values and loading states
            if (elementToReplace && parsedState.sections[section.section]) {
              const viewState = this.captureViewState();

              // Clear initialization flags before updating content
              this.querySelectorAll('[data-initialized]').forEach(el => {
                el.removeAttribute('data-initialized');
              });

              const selectorElement = elementToReplace.querySelector(section.selector);
              if (selectorElement) {
                selectorElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
              }

              this.restoreInputState(viewState.inputValues, id);
              this.restoreLoadingState(viewState.loadingVariants);
              this.restoreMediaContent(viewState.mediaNodes);
            }
          } else {
            // For other sections, update normally
            const targetElement = elementToReplace?.querySelector(section.selector) || elementToReplace;
            if (targetElement && parsedState.sections[section.section]) {
              targetElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }
        });

        publish(PUB_SUB_EVENTS.quantityUpdate, {
          cart: parsedState.cart,
        });

        // Fetch full cart state to update variant totals (parsedState.items only has the added item)
        fetch(`${routes.cart_url}.js`)
          .then(response => response.json())
          .then(fullCart => {
            this.cart = fullCart;
            this.updateVariantTotals(fullCart);
          })
          .catch(error => {
            console.error('Failed to fetch full cart for totals update:', error);
            // Fallback to what we have
            this.updateVariantTotals(parsedState.cart || parsedState);
          });

        // Force any protected values after DOM update
        this.forceProtectedValues();

        const resolvedDomQty = this.getVariantQuantityFromRows(id);
        if (resolvedDomQty !== null) {
          actualCartQty = resolvedDomQty;
        }
        if (actualCartQty === null || actualCartQty === undefined) {
          actualCartQty = targetQuantity;
        }

        const latestRequestedQty = this.latestRequestedQuantities.get(String(id));
        const chunkTarget = this.chunkedRequests.get(String(id));
        const hasQueuedUpdate = this.queuedRequests.has(id);
        const chunkActive = chunkTarget !== undefined;
        const requestStillInFlight = this.pendingRequests.has(id);
        const shouldPreserveValue = (requestStillInFlight || hasQueuedUpdate || chunkActive) && latestRequestedQty !== undefined && latestRequestedQty !== actualCartQty;
        const displayValue = shouldPreserveValue ? latestRequestedQty : undefined;

        this.syncVariantQuantityDisplay(id, actualCartQty, {
          preserveValue: shouldPreserveValue,
          value: displayValue,
        });
        this.getVariantRows(id).forEach((row) => {
          row.classList.toggle('quick-order-list__item--removed-product', actualCartQty === 0);
        });

        const limitReached = Boolean(exceededLimit && maxPermitted !== null);
        this.applyLimitState(id, actualCartQty, { limitReached });

        // Trigger BOLD.common integration for third-party apps
        if (typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.eventEmitter !== 'undefined') {
          BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', this.cart);
        }
      })
      .catch((error) => {
        requestFailed = true;
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.handleQuantityError(id, error);
        console.error('Error:', error);
      })
      .finally(() => {
        // Clear pending request
        this.pendingRequests.delete(id);
        
        // Process any queued request for this variant only if previous request succeeded
        if (!requestFailed && this.queuedRequests.has(id)) {
          const queuedRequest = this.queuedRequests.get(id);
          this.queuedRequests.delete(id);
          // Process the queued request after a small delay to avoid immediate collision
          setTimeout(() => {
            this.updateQuantity(id, queuedRequest.quantity, queuedRequest.sourceInput, queuedRequest.variantArray, queuedRequest.activeElementName);
          }, 100);
        } else if (requestFailed) {
          this.queuedRequests.delete(id);
        }
        
        this.querySelector('.quick-order-list__total').classList.remove('loading');
        
        // Hide loading spinner for the specific variant total
        this.disableVariantLoading(id);
        
        if (this.cart && this.cart.item_count === 0) {
          const removeAllButton = this.querySelector('.quick-order-list-remove-all-button');
          if (removeAllButton) removeAllButton.setAttribute('disabled', '');
        }
        // If its a variant array with all variants unselected or removed, disable the remove all products button
        if (variantArray && variantArray.every((item) => item.quantity === 0)) {
          const removeButton = this.querySelector(`quick-order-list-remove-button[data-index="${id}"]`);
          if (removeButton) removeButton.setAttribute('disabled', '');
        }

        if (!this.pendingRequests.has(id) && !this.queuedRequests.has(id)) {
          const finalQuantity = this.getCartQuantityForVariant(id);
          this.latestRequestedQuantities.set(String(id), finalQuantity);
        }

        this.defineInputsAndSections();
        initQuickOrderAccordions();
      });
  }

  handleLargeQuantityChange(id, currentQty, targetQty, sourceInput, variantArray, activeElementName) {
    const MAX_CHUNK_SIZE = 5;
    let currentStep = currentQty;

    const variantKey = String(id);
    this.chunkedRequests.set(variantKey, targetQty);

    const finalizeChunks = (requestFailed = false) => {
      this.pendingRequests.delete(id);
      this.chunkedRequests.delete(variantKey);
      this.querySelector('.quick-order-list__total').classList.remove('loading');
      this.disableVariantLoading(id);

      if (!requestFailed && this.queuedRequests.has(id)) {
        const queuedRequest = this.queuedRequests.get(id);
        this.queuedRequests.delete(id);
        setTimeout(() => {
          this.updateQuantity(id, queuedRequest.quantity, queuedRequest.sourceInput, queuedRequest.variantArray, queuedRequest.activeElementName);
        }, 100);
      } else if (requestFailed) {
        this.queuedRequests.delete(id);
      } else {
        const finalQuantity = this.getCartQuantityForVariant(id);
        this.latestRequestedQuantities.set(variantKey, finalQuantity);
      }

      if (!this.pendingRequests.has(id) && !this.queuedRequests.has(id) && !this.chunkedRequests.has(variantKey)) {
        this.defineInputsAndSections();
      }
    };

    const processNextChunk = () => {
      if (currentStep >= targetQty) {
        // We've reached the target quantity
        this.latestRequestedQuantities.set(variantKey, targetQty);
        finalizeChunks(false);
        return;
      }

      // Calculate next step (add up to MAX_CHUNK_SIZE items)
      const nextStep = Math.min(currentStep + MAX_CHUNK_SIZE, targetQty);
      
      // Use a timeout to ensure the previous request has fully completed
      setTimeout(() => {
        // Make a direct call to the original updateQuantity logic, but bypassing the large quantity check
        this.updateQuantityDirect(id, nextStep, sourceInput, variantArray, activeElementName)
          .then(() => {
            currentStep = nextStep;
            // Process the next chunk
            processNextChunk();
          })
          .catch((error) => {
            console.error(`Error in chunked quantity update for variant ${id}:`, error);
            // Stop processing on error
            this.handleQuantityError(id, error);
            finalizeChunks(true);
          });
      }, 200); // Small delay between chunks
    };

    // Start processing chunks
    processNextChunk();
  }

  updateQuantityDirect(id, quantity, sourceInput, variantArray, activeElementName) {
    return new Promise((resolve, reject) => {
      let quantityElement = null;
      if (sourceInput instanceof HTMLElement && sourceInput.closest('quick-order-list')) {
        quantityElement = sourceInput;
      }
      if (!quantityElement) {
        quantityElement = this.getQuantityInputElement(id);
      }
      const currentCartQty = parseInt(quantityElement?.dataset.cartQuantity) || 0;

      let normalizedQuantity = parseInt(quantity);
      if (Number.isNaN(normalizedQuantity) || normalizedQuantity < 0) {
        normalizedQuantity = 0;
      }

      const maxPermitted = this.getMaxPermittedQuantity(id);
      if (maxPermitted !== null && normalizedQuantity > maxPermitted) {
        normalizedQuantity = maxPermitted;
      }

      let routeUrl, requestData;

      if (currentCartQty === 0 && normalizedQuantity > 0) {
        routeUrl = routes.cart_add_url;
        requestData = {
          items: [{ id: parseInt(id), quantity: normalizedQuantity }],
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        };
      } else {
        routeUrl = routes.cart_update_url;
        const updates = {};
        updates[id] = normalizedQuantity;
        requestData = {
          updates: updates,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        };
      }

      const body = JSON.stringify(requestData);
      const fetchConfigObject = fetchConfig();

      fetch(routeUrl, { ...fetchConfigObject, ...{ body } })
        .then((response) => {
          if (!response.ok) {
            return response.text().then(errorText => {
              console.error(`HTTP ${response.status} error:`, errorText);
              throw new Error(`HTTP error! status: ${response.status}, details: ${errorText}`);
            });
          }
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          this.cart = parsedState.cart || parsedState;

          // Update UI sections
          this.getSectionsToRender().forEach((section) => {
            const elementToReplace = document.getElementById(section.id);
            if (!elementToReplace || !parsedState.sections[section.section]) {
              return;
            }

            if (section.id === 'quick-order-list') {
              const viewState = this.captureViewState();

              this.querySelectorAll('[data-initialized]').forEach(el => {
                el.removeAttribute('data-initialized');
              });

              const selectorElement = elementToReplace.querySelector(section.selector);
              if (selectorElement) {
                selectorElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
              }

              this.restoreInputState(viewState.inputValues, id);
              this.restoreLoadingState(viewState.loadingVariants);
              this.restoreMediaContent(viewState.mediaNodes);
            } else {
              const selectorElement = elementToReplace.querySelector(section.selector);
              if (selectorElement) {
                selectorElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
              }
            }
          });

          let actualCartQty = this.resolveCartQuantityFromResponse(parsedState, id);
          const resolvedDomQty = this.getVariantQuantityFromRows(id);
          if (resolvedDomQty !== null) {
            actualCartQty = resolvedDomQty;
          }
          if (actualCartQty === null || actualCartQty === undefined) {
            actualCartQty = normalizedQuantity;
          }

        const latestRequestedQty = this.latestRequestedQuantities.get(String(id));
        const chunkTarget = this.chunkedRequests.get(String(id));
        const hasQueuedUpdate = this.queuedRequests.has(id);
        const hasPending = this.pendingRequests.has(id);
        const chunkActive = chunkTarget !== undefined;
        const shouldPreserveValue = (hasQueuedUpdate || hasPending || chunkActive) && latestRequestedQty !== undefined && latestRequestedQty !== actualCartQty;
          const displayValue = shouldPreserveValue ? latestRequestedQty : undefined;

          this.syncVariantQuantityDisplay(id, actualCartQty, {
            preserveValue: shouldPreserveValue,
            value: displayValue,
          });

          this.updateVariantTotals(parsedState.cart || parsedState);
          const limitReached = Boolean(exceededLimit && maxPermitted !== null);
          this.applyLimitState(id, actualCartQty, { limitReached });
          this.defineInputsAndSections();
          initQuickOrderAccordions();
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-order', cartData: parsedState });
          if (!this.pendingRequests.has(id) && !this.queuedRequests.has(id) && !this.chunkedRequests.has(String(id))) {
            this.latestRequestedQuantities.set(String(id), actualCartQty);
          }
          resolve();
        })
        .catch((error) => {
          console.error('Error in direct quantity update:', error);
          reject(error);
        });
    });
  }

  handleQuantityError(variantId, error, options = {}) {
    const message = options.rawMessage ? (error || this.getDefaultErrorMessage()) : this.extractErrorMessage(error);
    let resolvedMessage = message || this.getDefaultErrorMessage();

    const normalizedMessage = (resolvedMessage || '').toLowerCase();
    const hitsMaxLimit = normalizedMessage.includes('maximum quantity');

    if (hitsMaxLimit) {
      const actualQty = this.getCartQuantityForVariant(variantId);
      resolvedMessage = this.formatAvailabilityMessage(actualQty);
      this.showVariantLimitWarning(variantId, actualQty);
    } else {
      this.showGlobalError(resolvedMessage);
      this.showVariantError(variantId, resolvedMessage, { persistent: true });
    }
    this.resetQuantityInputToCartQuantity(variantId);
    this.disableVariantLoading(variantId);
    this.querySelector('.quick-order-list__total')?.classList.remove('loading');
    this.queuedRequests.delete(variantId);

    const quantityElement = this.getQuantityInputElement(variantId);
    if (quantityElement) {
      quantityElement.focus();
    }
  }

  extractErrorMessage(error) {
    if (!error) {
      return this.getDefaultErrorMessage();
    }

    if (typeof error === 'string') {
      return error;
    }

    if (error.description) {
      return error.description;
    }

    if (error.errors) {
      const directError = this.extractFirstError(error.errors);
      if (directError) {
        return directError;
      }
    }

    const message = error.message || '';
    const jsonMatch = message.match(/\{.*\}/);

    if (jsonMatch) {
      try {
        const parsed = JSON.parse(jsonMatch[0]);
        if (parsed.description) {
          return parsed.description;
        }
        if (parsed.errors) {
          const nestedError = this.extractFirstError(parsed.errors);
          if (nestedError) {
            return nestedError;
          }
        }
      } catch (parseError) {
        console.warn('Failed to parse error JSON:', parseError);
      }
    }

    return message || this.getDefaultErrorMessage();
  }

  extractFirstError(errors) {
    if (!errors) {
      return null;
    }

    if (typeof errors === 'string') {
      return errors;
    }

    if (Array.isArray(errors)) {
      return errors[0];
    }

    if (typeof errors === 'object') {
      const firstValue = Object.values(errors)[0];
      if (Array.isArray(firstValue)) {
        return firstValue[0];
      }
      return firstValue;
    }

    return null;
  }

  showGlobalError(message) {
    const errorElements = this.querySelectorAll('.quick-order-list-error, .quick-order-list-error-message');
    errorElements.forEach((element) => {
      element.textContent = message;
    });
  }

  clearGlobalError() {
    const errorElements = this.querySelectorAll('.quick-order-list-error, .quick-order-list-error-message');
    errorElements.forEach((element) => {
      element.textContent = '';
    });
  }

  showVariantError(variantId, message, { persistent = false } = {}) {
    this.getVariantErrorContainers(variantId).forEach((errorContainer) => {
      if (!errorContainer) {
        return;
      }
      const errorText = errorContainer.querySelector('.variant-item__error-text');
      if (errorText) {
        errorText.textContent = message;
      }
      if (persistent) {
        errorContainer.dataset.persistent = 'true';
      } else {
        delete errorContainer.dataset.persistent;
      }
      errorContainer.classList.add('active');
    });
  }

  clearVariantError(variantId, { force = false } = {}) {
    this.getVariantErrorContainers(variantId).forEach((errorContainer) => {
      if (!errorContainer) {
        return;
      }

      if (errorContainer.dataset.persistent === 'true' && !force) {
        return;
      }

      const errorText = errorContainer.querySelector('.variant-item__error-text');
      if (errorText) {
        errorText.textContent = '';
      }
      delete errorContainer.dataset.persistent;
      errorContainer.classList.remove('active');
    });
  }

  showVariantLimitWarning(variantId, quantity) {
    const message = this.formatAvailabilityMessage(quantity);
    this.clearGlobalError();
    this.showVariantError(variantId, message, { persistent: true });
  }

  formatAvailabilityMessage(quantity) {
    const safeQuantity = typeof quantity === 'number' && !Number.isNaN(quantity) ? quantity : 0;
    const noun = safeQuantity === 1 ? 'item' : 'items';
    const verb = safeQuantity === 1 ? 'was' : 'were';
    return `Only ${safeQuantity} ${noun} ${verb} added to your cart due to availability.`;
  }

  resetQuantityInputToCartQuantity(variantId) {
    const currentCartQty = this.getCartQuantityForVariant(variantId);
    this.syncVariantQuantityDisplay(variantId, currentCartQty);
    this.latestRequestedQuantities.set(String(variantId), currentCartQty);
  }

  getCartQuantityForVariant(variantId) {
    if (this.cart && Array.isArray(this.cart.items)) {
      const match = this.cart.items.find((item) => item.variant_id == variantId);
      if (match) {
        return match.quantity;
      }
    }

    const rowQuantity = this.getVariantQuantityFromRows(variantId);
    if (rowQuantity !== null) {
      return rowQuantity;
    }

    const inputs = this.getVariantInputs(variantId);
    for (const input of inputs) {
      const attrQuantity = parseInt(input.getAttribute('data-cart-quantity'));
      if (!Number.isNaN(attrQuantity)) {
        return attrQuantity;
      }
    }

    return 0;
  }

  getDefaultErrorMessage() {
    return (window.cartStrings && window.cartStrings.error) || 'There was a problem updating your cart.';
  }

  getQuantityInputElement(variantId) {
    const inputs = this.getVariantInputs(variantId);
    if (inputs.length) {
      return inputs[0];
    }
    return document.getElementById(`Quantity-${variantId}`) || document.getElementById(`updates_${variantId}`);
  }

  getVariantErrorContainers(variantId) {
    const mobileError = document.getElementById(`Quick-order-list-item-error-mobile-${variantId}`);
    const desktopError = document.getElementById(`Quick-order-list-item-error-desktop-${variantId}`);
    return [mobileError, desktopError];
  }

  getVariantInputs(variantId) {
    return this.querySelectorAll(`input[data-index="${variantId}"]`);
  }

  getVariantRows(variantId) {
    return this.querySelectorAll(`[data-variant-id="${variantId}"]`);
  }

  getVariantQuantityFromRows(variantId) {
    const rows = this.getVariantRows(variantId);
    for (const row of rows) {
      const qty = parseInt(row.dataset.cartQty);
      if (!Number.isNaN(qty)) {
        return qty;
      }
    }
    return null;
  }

  normalizeQuantity(quantity) {
    const parsed = Number(quantity);
    if (Number.isFinite(parsed) && parsed >= 0) {
      return Math.round(parsed);
    }
    return null;
  }

  syncVariantQuantityDisplay(variantId, quantity, options = {}) {
    const normalized = this.normalizeQuantity(quantity);
    const { value, preserveValue = false } = options;

    if (normalized !== null) {
      this.getVariantRows(variantId).forEach((row) => {
        row.setAttribute('data-cart-qty', normalized);
      });
    }

    this.getVariantInputs(variantId).forEach((input) => {
      if (normalized !== null) {
        input.setAttribute('data-cart-quantity', normalized);
      }

      let nextValue;
      if (value !== undefined) {
        nextValue = value;
      } else if (!preserveValue && normalized !== null) {
        nextValue = normalized;
      }

      if (nextValue !== undefined && nextValue !== null) {
        const quantityComponent = input.closest('quantity-input');
        const currentValue = parseInt(input.value);
        const incomingValue = parseInt(nextValue);

        // Get protection state from global store
        const protectionState = quantityProtectionState.get(String(variantId));
        const isUserInitiated = protectionState && protectionState.userInitiated;
        const expectedValue = protectionState ? protectionState.expectedValue : null;
        const lastUserValue = protectionState ? protectionState.lastUserValue : null;

        const componentId = quantityComponent ? quantityComponent.componentId : 'none';

        // Logic: Only accept server updates that match the user's latest intention
        let shouldUpdate = false;
        if (!isUserInitiated) {
          // No user interaction - always update
          shouldUpdate = true;
        } else if (lastUserValue !== null && incomingValue === lastUserValue) {
          // Server response matches exactly what the user last clicked - accept it
          shouldUpdate = true;
          // Clear protection since we got the exact result the user wanted
          quantityProtectionState.delete(String(variantId));
        } else {
          // Server response doesn't match user's latest intention - skip
          shouldUpdate = false;
        }

        if (shouldUpdate) {
          input.value = nextValue;
        } else {
        }
      }

      const quantityComponent = input.closest('quantity-input');
      if (quantityComponent && typeof quantityComponent.validateQtyRules === 'function') {
        quantityComponent.validateQtyRules();
      }
    });
  }

  resolveCartQuantityFromResponse(response, variantId) {
    if (!response) {
      return null;
    }

    const sources = [];
    if (response.cart && Array.isArray(response.cart.items)) {
      sources.push(response.cart.items);
    }
    if (response.cart && Array.isArray(response.cart.line_items)) {
      sources.push(response.cart.line_items);
    }
    if (Array.isArray(response.items)) {
      sources.push(response.items);
    }

    const numericId = Number(variantId);

    for (const collection of sources) {
      const match = collection.find((item) => {
        const variantValue = item.variant_id ?? item.id;
        return Number(variantValue) === numericId;
      });
      if (match) {
        const quantityValue = match.quantity ?? match.qty ?? match.quantity_available;
        const parsedQuantity = Number(quantityValue);
        if (Number.isFinite(parsedQuantity)) {
          return parsedQuantity;
        }
      }
    }

    return null;
  }

  getMaxPermittedQuantity(variantId) {
    const quantityElement = this.getQuantityInputElement(variantId);
    if (!quantityElement) {
      return null;
    }

    const datasetMax = parseInt(quantityElement.dataset.max);
    const attrMax = quantityElement.hasAttribute('max') ? parseInt(quantityElement.getAttribute('max')) : NaN;
    const available = parseInt(quantityElement.dataset.available);
    const inventoryPolicy = quantityElement.dataset.inventoryPolicy;

    const maxValues = [];
    if (!Number.isNaN(datasetMax)) {
      maxValues.push(datasetMax);
    }
    if (!Number.isNaN(attrMax)) {
      maxValues.push(attrMax);
    }
    if (inventoryPolicy === 'deny' && !Number.isNaN(available)) {
      maxValues.push(available);
    }

    if (!maxValues.length) {
      return null;
    }

    return Math.min(...maxValues);
  }

  applyLimitState(variantId, actualCartQty, options = {}) {
    const { limitReached = false } = options;
    const limit = this.getMaxPermittedQuantity(variantId);
    const atOrBeyondLimit = limit !== null && actualCartQty >= limit && actualCartQty > 0;

    if (atOrBeyondLimit && limitReached) {
      this.showVariantLimitWarning(variantId, actualCartQty);
    } else {
      this.clearVariantError(variantId, { force: true });
      this.clearGlobalError();
    }
  }

  updateLiveRegions(id, cart) {
    const lineItemError = document.getElementById(`quick-order-list-item-error-${id}`);
    if (lineItemError) {
      lineItemError.querySelector('.sr-only').innerHTML = '';
    }

    const cartStatus = document.getElementById('quick-order-list-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  forceProtectedValues() {
    // Force correct values for all protected inputs
    quantityProtectionState.forEach((state, variantId) => {
      if (state.userInitiated && state.lastUserValue !== null) {
        const input = document.querySelector(`input[data-index="${variantId}"]`);
        const currentValue = parseInt(input.value);
        if (input && currentValue !== state.lastUserValue) {
          input.value = state.lastUserValue;
        }
      }
    });
  }

  getSectionInnerHTML(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    return element.innerHTML;
  }

  refresh(options = {}) {
    const { preserveInputValues = true, cartData = null } = options;

    return fetch(`${window.location.pathname}?sections=${this.getSectionsToRender().map((section) => section.section).join(',')}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((response) => {
        // If we have cart data, sync quantities immediately before updating DOM
        if (cartData && !preserveInputValues) {
          this.cart = cartData;
        }

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.getElementById(section.id);
          if (!elementToReplace) {
            return;
          }

          if (section.id === 'quick-order-list') {
            const viewState = this.captureViewState();

            // Clear initialization flags before updating content
            this.querySelectorAll('[data-initialized]').forEach(el => {
              el.removeAttribute('data-initialized');
            });

            const target = elementToReplace.querySelector(section.selector) || elementToReplace;
            target.innerHTML = this.getSectionInnerHTML(response[section.section], section.selector);

            // Only restore input values if requested (e.g., when updating from within the form)
            // Don't restore when external updates happen (e.g., cart drawer changes)
            if (preserveInputValues) {
              this.restoreInputState(viewState.inputValues);
            }
            this.restoreLoadingState(viewState.loadingVariants);
            this.restoreMediaContent(viewState.mediaNodes);
          } else {
            const target = elementToReplace.querySelector(section.selector) || elementToReplace;
            target.innerHTML = this.getSectionInnerHTML(response[section.section], section.selector);
          }
        });

        // Re-initialize after refresh
        this.defineInputsAndSections();
        initQuickOrderAccordions();

        // If we didn't preserve input values, sync quantities from the cart data
        if (!preserveInputValues && cartData) {
          // Update with actual cart quantities
          if (cartData.items) {
            cartData.items.forEach(item => {
              this.syncVariantQuantityDisplay(item.variant_id, item.quantity);
              this.latestRequestedQuantities.set(String(item.variant_id), item.quantity);
            });
            this.updateVariantTotals(cartData);
          }
        }
      })
      .catch((error) => {
        console.error('[QuickOrderList] Refresh failed:', error);
        throw error;
      });
  }

  enableVariantLoading(variantId) {
    // Show loading spinner for variant total cells
    const variantTotalCells = document.querySelectorAll(`[data-variant-total="${variantId}"] .loading-overlay`);
    
    variantTotalCells.forEach(overlay => {
      overlay.classList.remove('hidden');
    });
  }

  disableVariantLoading(variantId) {
    // Hide loading spinner for variant total cells and show the price
    const variantTotalCells = document.querySelectorAll(`[data-variant-total="${variantId}"]`);
    
    variantTotalCells.forEach(cell => {
      const overlay = cell.querySelector('.loading-overlay');
      const price = cell.querySelector('.price');
      
      if (overlay) {
        overlay.classList.add('hidden');
        overlay.style.display = ''; // Reset display
      }
      if (price) {
        price.style.visibility = ''; // Show price again
      }
    });
  }

  updateVariantTotals(cart = null) {
    const cartData = cart || this.cart;
    if (!cartData || !cartData.items) return;
    
    // Get the current product from the page
    const currentProduct = window.product;
    if (!currentProduct) return;
    
    // Calculate totals for this product's variants
    let productSubtotal = 0;
    let totalQuantity = 0;
    
    cartData.items.forEach(item => {
      // Check if this cart item belongs to the current product
      let belongsToCurrentProduct = false;
      
      if (currentProduct.variants && currentProduct.variants.find(variant => variant.id === item.variant_id)) {
        belongsToCurrentProduct = true;
      } else if (currentProduct.id && item.product_id === currentProduct.id) {
        belongsToCurrentProduct = true;
      } else {
        // Fallback: check if we have a variant total cell for this item on the page
        const variantTotalCell = document.querySelector(`[data-variant-total="${item.variant_id}"]`);
        belongsToCurrentProduct = !!variantTotalCell;
      }
      
      if (belongsToCurrentProduct) {
        productSubtotal += item.original_line_price;
        totalQuantity += item.quantity;
        
        // Update individual variant total in the table
        const variantTotalCell = document.querySelector(`[data-variant-total="${item.variant_id}"] .price`);
        if (variantTotalCell) {
          const formattedPrice = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: cartData.currency || 'USD'
          }).format(item.original_line_price / 100);
          variantTotalCell.textContent = formattedPrice;

          // Update data-total attribute on quantity column for mobile display
          const variantRow = document.querySelector(`#Variant-${item.variant_id}`);
          if (variantRow) {
            const quantityCol = variantRow.querySelector('.variant-item__quantity');
            if (quantityCol) {
              quantityCol.setAttribute('data-total', formattedPrice);
            }
          }
        }
      }
    });

    // Clear data-total for variants not in cart
    this.querySelectorAll('.variant-item__quantity').forEach(quantityCol => {
      const variantRow = quantityCol.closest('.variant-item');
      if (variantRow) {
        const variantId = variantRow.dataset.variantId;
        const itemInCart = cartData.items?.find(item => item.variant_id == variantId);
        if (!itemInCart || itemInCart.quantity === 0) {
          quantityCol.setAttribute('data-total', '$0.00');
        }
      }
    });
    
    // Update main total
    const totalElement = document.querySelector('.totals__subtotal-value');
    if (totalElement) {
      totalElement.textContent = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: cartData.currency || 'USD'
      }).format(productSubtotal / 100);
    }
    
    // Calculate total quantity for current product
    let productTotalQuantity = 0;
    this.querySelectorAll('input[type="number"]').forEach(input => {
      const quantity = parseInt(input.value) || 0;
      productTotalQuantity += quantity;
    });

    // Update total items count
    const totalItemsElement = document.querySelector('.quick-order-list__summary-count');
    if (totalItemsElement) {
      totalItemsElement.textContent = productTotalQuantity;
    }

    // Update total price
    const totalPriceElement = document.querySelector('.quick-order-list__summary-price');
    if (totalPriceElement && cartData) {
      totalPriceElement.textContent = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: cartData.currency || 'USD'
      }).format(productSubtotal / 100);
    }

    // Always show View Cart button
    const viewCartButton = document.querySelector('.quick-order-list__summary-view-cart');
    if (viewCartButton) {
      viewCartButton.classList.remove('hidden');
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'quick-order-list',
        section: document.querySelector('[data-section]').dataset.section,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'quick-order-list-total',
        section: document.querySelector('[data-section]').dataset.section,
        selector: '.quick-order-list__total',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('quick-order-list', QuickOrderList);
